import React from 'react'
import { SwitchProps, Switch as ChakraSwitch } from '@chakra-ui/react'

function Switch(props: SwitchProps) {
  return (
    <ChakraSwitch {...props} />
  )
}

export default Switch